import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DataStorageService {
  addDataToLocalStorage(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      console.error(e);
    }
  }

  getDataFromLocalStorage(key: string): string | null {
    return localStorage.getItem(key);
  }

  clearData() {
    localStorage.clear();
  }
}
